<template>
  <Teleport to="#alerts-container">
    <div class="alerts">
      <Alert
        v-for="alert in alerts"
        :key="alert.id"
        class="alert"
        :variant="alert.variant"
        :text="alert.text"
        @click="close(alert.id)"
      />
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';

import Alert from './alert.vue';
import { useAlertsStore } from './alerts.composable';

const alertsStore = useAlertsStore();
const { alerts } = storeToRefs(alertsStore);

function close(id: string) {
  alertsStore.close(id);
}
</script>

<style scoped lang="scss">
@import 'styles/mixins/layout.mixins';

.alerts {
  position: fixed;
  bottom: var(--t-spacing-xl);
  left: var(--t-spacing-xl);
  // Toasts report the outcome of actions taken inside modals, so they layer above the modal's 100.
  z-index: 200;

  display: flex;
  flex-direction: column;
  gap: var(--t-spacing-md);

  width: auto;
  height: auto;

  .alert {
    width: auto;
    min-width: min(calc(100vw - (var(--t-spacing-xl) * 2)), 20rem);
  }
}
</style>
